import { base, token } from '../../api.ts';
import type { AgentInfo } from '../../agents-api.ts';
import { h } from '../../ui.ts';

/**
 * The agent's browser, live (design-docs/0031): JPEG frames from Chrome's screencast over a WebSocket, shown while
 * this card is on screen; the address bar follows the page the agent is on.
 */
export function liveCard(a: AgentInfo): HTMLElement | null {
  if (!a.browser?.live) return null;
  const img = h('img', { class: 'live-frame', alt: 'The agent’s browser, live' });
  const address = h('span', { class: 'mono truncate live-url' }, 'connecting…');
  const dot = h('span', { class: 'dot pulse live-dot' });
  const card = h(
    'div',
    { class: 'card live-card' },
    h(
      'div',
      { class: 'card-head' },
      h('span', { class: 'label' }, 'Live browser'),
      h('span', { class: 'chip success' }, dot, 'Live'),
    ),
    h('div', { class: 'live-bar' }, address),
    h('div', { class: 'live-screen' }, img),
  );
  const url = `${base().replace(/^http/, 'ws')}/agents/${encodeURIComponent(a.id)}/live?token=${encodeURIComponent(token())}`;
  const ws = new WebSocket(url);
  ws.binaryType = 'blob';
  let shown: string | null = null;
  ws.onmessage = (m) => {
    if (typeof m.data === 'string') {
      const msg = JSON.parse(m.data) as { type: string; url?: string };
      if (msg.type === 'offline') {
        address.textContent = 'The browser is closed. It opens when the agent works again.';
        dot.classList.remove('pulse');
      } else if (msg.type === 'page') address.textContent = msg.url || 'about:blank';
      return;
    }
    const next = URL.createObjectURL(m.data as Blob);
    img.src = next;
    if (shown) URL.revokeObjectURL(shown);
    shown = next;
  };
  // stop streaming once the card is gone (navigated away or redrawn)
  const watch = setInterval(() => {
    if (card.isConnected) return;
    clearInterval(watch);
    ws.close();
    if (shown) URL.revokeObjectURL(shown);
  }, 1000);
  return card;
}
